import { Above } from '@jetshop/ui/Breakpoints';
import React from 'react';
import { styled } from 'linaria/react';

const ImageGridWrapper = styled('div')`
  display: grid;
  grid-template-columns: repeat(${props => props.rowcolumns}, 1fr);
  width: 100%;
  max-width: 90rem;
  margin: auto;
  gap: 1rem;

  .full-width {
    max-width: 100%;
  }

  .box-wrapper {
    margin: 0;
  }
`;
export const ImageGrid = ({
  desktopColumns,
  mobileColumns,
  fullWidth,
  children
}) => {
  return (
    <Above breakpoint="lg">
      {matches => (
        <ImageGridWrapper
          rowcolumns={
            matches ? desktopColumns?.value ?? 3 : mobileColumns?.value ?? 1
          }
          className={fullWidth?.value && 'full-width'}
        >
          {children}
        </ImageGridWrapper>
      )}
    </Above>
  );
};
